import { render, staticRenderFns } from "./GraphByStatus.vue?vue&type=template&id=a2295a54&lang=html&"
import script from "./GraphByStatus.vue?vue&type=script&lang=js&"
export * from "./GraphByStatus.vue?vue&type=script&lang=js&"
import style0 from "./GraphByStatus.vue?vue&type=style&index=0&id=a2295a54&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2295a54')) {
      api.createRecord('a2295a54', component.options)
    } else {
      api.reload('a2295a54', component.options)
    }
    module.hot.accept("./GraphByStatus.vue?vue&type=template&id=a2295a54&lang=html&", function () {
      api.rerender('a2295a54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statistics/components/GraphByStatus.vue"
export default component.exports